{
  "actions": "Azioni",
  "hideButtonLabel": "Mostra meno",
  "noTags": "Nessuno",
  "showAllButtonLabel": "Mostra tutto ({tagCount, number})"
}
